export const REVIEW_SOURCE_ICON_PATHS = Object.freeze({
    google: '/images/google-badge.svg',
    nicejob: '/images/nicejob-badge-v2.svg',
    facebook: '/images/facebook-badge.svg',
});

export function normalizeReviewSourceIcon(icon) {
    const value = String(icon ?? '').trim();
    if (!value) return '';

    const lower = value.toLowerCase();
    if (
        lower.includes('/images/nicejob-badge.svg') &&
        !lower.includes('/images/nicejob-badge-v2.svg')
    ) {
        return REVIEW_SOURCE_ICON_PATHS.nicejob;
    }

    return value;
}

export function getReviewSourceAlt(icon) {
    const value = normalizeReviewSourceIcon(icon).toLowerCase().trim();

    if (value.includes('google')) return 'Google review';
    if (value.includes('nicejob')) return 'NiceJob review';
    if (value.includes('facebook')) return 'Facebook review';

    return 'Review source';
}
